import type { ReactNode } from 'react';
import { Wordmark } from '@/components/wordmark';

/**
 * Inloggen/registreren (design-skill: ui_kits/webapp/Auth.jsx). Mobiel één
 * kolom; vanaf lg een donker productvlak rechts. Geen voorbeeldquotes: die
 * zijn verzonnen en horen niet in productie.
 */
export function AuthLayout(props: { title: string; description: string; children: ReactNode }) {
  return (
    <div className="grid min-h-dvh lg:grid-cols-2">
      <div className="flex flex-col gap-8 p-4 sm:p-6 lg:px-10">
        <header>
          <Wordmark />
        </header>
        <main className="m-auto grid w-full max-w-[400px] gap-6 pt-4 pb-12">
          <div className="grid gap-2">
            <h1 className="text-h1 font-bold lg:text-h1-lg">{props.title}</h1>
            <p className="text-muted-foreground">{props.description}</p>
          </div>
          {props.children}
        </main>
      </div>
      <aside className="m-4 ml-0 hidden flex-col justify-end gap-4 rounded-3xl bg-foreground p-12 text-background lg:flex">
        <p className="max-w-[22ch] text-h2 font-semibold">
          Oefeningen vinden, trainingen samenstellen en uitvoeren in de zaal.
        </p>
        <p className="text-sm opacity-70">Voor volleybaltrainers</p>
      </aside>
    </div>
  );
}
